import { Middleware } from '@reduxjs/toolkit';
import { setStateType } from '../reducer/coreScriptReducer';
import { RootState } from '../Store';
import { StateType } from '@safeguardproperties/corescript-react-npm/dist/types';
import { REHYDRATE, PURGE } from 'redux-persist/es/constants';

const syncStateMiddleware: Middleware<unknown, RootState> =
  (store) => (next) => (action: any) => {
    // Handle REHYDRATE before processing
    if (action.type === REHYDRATE) {
      const payload = action.payload?.contextId;

      if (payload) {
        const queryParams = new URLSearchParams(globalThis?.location?.search);
        const contextId = queryParams.get('id') || '';

        if (payload !== contextId) {
          // Use PURGE action with specific configuration
          store.dispatch({
            type: PURGE,
            key: 'root',
            result: () => Promise.resolve(),
          });
        }
      }
    }

    // Process the action
    const result = next(action);

    if (action.type === 'contextId/setAuditState') {
      const isAudit = store.getState().contextId.isAudit;
      const stateType: StateType = isAudit ? 'audit' : 'web'; // Adjust based on your logic

      store.dispatch(setStateType(stateType));
    }

    return result;
  };

export default syncStateMiddleware;
